// extracted by mini-css-extract-plugin
export default {"base":"Alert_base__rn5PN"};